module.exports = __webpack_public_path__ + "static/media/Capsula v3.f14f7a8f.glb";